module.exports = __webpack_public_path__ + "static/media/Aubameyang.c709f50d.jpg";